/*
    Cart JS
*/

// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async (response) => {
    try {
        console.log('Cart update response:', response);

        const offcanvasCart = document.querySelector('#offcanvas-cart');
        const cartPage = document.querySelector('#cart');

        if (offcanvasCart) offcanvasCart.classList.add('loading');
        if (cartPage) cartPage.classList.add('loading');

        // Fetch the current page to get updated cart content
        const newResponse = await fetch(window.location.href);
        if (!newResponse.ok) {
            console.error('Error fetching updated cart content');
            return;
        }

        const text = await newResponse.text();
        const newDocument = new DOMParser().parseFromString(text, 'text/html');

        // Update offcanvas cart if it exists
        if (offcanvasCart) {
            const newOffcanvasBody = newDocument.querySelector('#offcanvas-cart .offcanvas-body');
            const newOffcanvasFooter = newDocument.querySelector('#offcanvas-cart .offcanvas-footer');
            
            if (newOffcanvasBody && offcanvasCart.querySelector('.offcanvas-body')) {
                offcanvasCart.querySelector('.offcanvas-body').replaceWith(newOffcanvasBody);
            }
            
            if (newOffcanvasFooter && offcanvasCart.querySelector('.offcanvas-footer')) {
                offcanvasCart.querySelector('.offcanvas-footer').replaceWith(newOffcanvasFooter);
            }
        }

        // Update cart page if it exists
        if (cartPage) {
            const newCartPage = newDocument.querySelector('#cart');
            if (newCartPage) {
                cartPage.replaceWith(newCartPage);
            }
        }

        // Update cart count badges
        const newCartCountBadge = newDocument.querySelector('.cart-count-badge');
        if (newCartCountBadge) {
    document.querySelectorAll('.cart-count-badge').forEach((badge) => {
                badge.textContent = newCartCountBadge.textContent;
                badge.removeAttribute('hidden');
            });
        }

        if (offcanvasCart) offcanvasCart.classList.remove('loading');
        if (cartPage) cartPage.classList.remove('loading');

        window.dispatchEvent(new Event('updated.theme.cart'));

        // Show appropriate alerts based on the response
    if (response.ok) {
        if (response.url.includes('add.js')) {
                if (offcanvasCart) {
                    offcanvasCart.querySelector('#offcanvas-cart-alert-add')?.removeAttribute('hidden');

                    // Try to parse the response to determine if multiple items were added
                    try {
                        const data = await response.clone().json();

            if (data.items?.length > 1) {
                            const elemAlertItemsAdded = offcanvasCart.querySelector('#offcanvas-cart-alert-add [data-alert-items-added]');
                            if (elemAlertItemsAdded) {
                                elemAlertItemsAdded.textContent = elemAlertItemsAdded.textContent.replace('[count]', data.items.length);
                                elemAlertItemsAdded.removeAttribute('hidden');
                            }
                        } else {
                            offcanvasCart.querySelector('#offcanvas-cart-alert-add [data-alert-item-added]')?.removeAttribute('hidden');
                        }
                    } catch (e) {
                        console.error('Error parsing response data:', e);
                        // Fallback to showing single item added alert
                        offcanvasCart.querySelector('#offcanvas-cart-alert-add [data-alert-item-added]')?.removeAttribute('hidden');
                    }
                }
            } else {
                offcanvasCart?.querySelector('#offcanvas-cart-alert-updated')?.removeAttribute('hidden');
            }
        } else {
            try {
                const data = await response.clone().json();
                const alert = offcanvasCart?.querySelector('#offcanvas-cart-alert-error');
                if (alert && data.message) {
                    alert.querySelector('span').textContent = `${data.message}${data.description ? ' - ' + data.description : ''}`;
                    alert.removeAttribute('hidden');
    }
            } catch (e) {
                console.error('Error parsing error response:', e);
            }
        }

        // Hide offcanvas if cart is empty
    if (offcanvasCart?.querySelector('#offcanvas-cart-empty')) {
        setTimeout(() => {
                if (window.bootstrap && offcanvasCart) {
                    bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart).hide();
                }
            }, 1000);
        }
    } catch (error) {
        console.error('Error refreshing cart contents:', error);
        
        // Remove loading state in case of error
        const offcanvasCart = document.querySelector('#offcanvas-cart');
        const cartPage = document.querySelector('#cart');
        
        if (offcanvasCart) offcanvasCart.classList.remove('loading');
        if (cartPage) cartPage.classList.remove('loading');
    }
}

// Unified function for handling quantity changes
const handleCartQuantityChange = async (input) => {
    const lineItemKey = input.dataset.lineItemKey;

    // Check if lineItemKey is valid
    if (!lineItemKey) {
        console.error('Error: No valid line item key found');
        return;
    }

    try {
        // Get the new quantity
        const newQty = parseInt(input.value) || 0;

        // Get current cart to check if this might empty the cart
        const currentCartResponse = await fetch('/cart.js');
        const currentCart = await currentCartResponse.json();

        // Find the current item
        const currentItem = currentCart.items.find(item => item.key === lineItemKey);
        const currentQty = currentItem ? currentItem.quantity : 0;

        // Check if this change would empty the cart
        const wouldEmptyCart = (currentCart.item_count - currentQty + newQty === 0) || (currentCart.item_count === 1 && newQty === 0);

        // Update the quantity
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: lineItemKey,
                quantity: newQty
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error('Error updating quantity:', errorData);
            // Optionally, revert the input value to the original quantity
            if (currentItem) {
                input.value = currentItem.quantity;
            }
            return;
        }

        // If this change emptied the cart, clear discounts
        if (wouldEmptyCart) {
            console.log('Cart is now empty after quantity change - clearing discounts');

            // Clear discount cookies
            document.cookie = "discount_applied=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            document.cookie = "discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";

            // Use fetch to clear discounts without page reload
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: '' })
            });

            // Refresh cart contents after clearing discounts
            await window.refreshCartContents(response);

            // Reload the page to ensure discount is cleared from Shopify session
            if (document.querySelector('#cart')) { // only reload if on cart page
              window.location.href = '/cart';
            }
        } else {
            // Just refresh cart contents normally
            window.refreshCartContents(response);
        }
    } catch (error) {
        console.error('Error updating cart quantity:', error);
    }
}

// Quantity Inputs for cart drawer
window.onChangeQty = async (input) => {
    await handleCartQuantityChange(input);
}

// Quantity Inputs for cart page
window.onChangeCartQty = async (input) => {
    await handleCartQuantityChange(input);
}

// Remove Buttons
window.onRemoveCartItem = async (btn) => {
    const lineItemKey = btn.dataset.lineItemKey;
    
    // Check if lineItemKey is valid
    if (!lineItemKey) {
        console.error('Error: No valid line item key found');
        return;
    }
    
    try {
        // Get current cart to check if this is the last item
        const currentCartResponse = await fetch('/cart.js');
        const currentCart = await currentCartResponse.json();
        const isLastItem = currentCart.item_count === 1;
        
        // If this is the last item, we'll need to clear discounts after removing it
        if (isLastItem) {
            console.log('Removing last item from cart - will clear discounts after');
        }
        
        // Remove the item
    const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
                id: lineItemKey,
            quantity: 0
        })
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            console.error('Error removing item:', errorData);
            return;
        }
        
        // If this was the last item, clear discounts
        if (isLastItem) {
            console.log('Last item removed - clearing discounts');
            
            // Clear discount cookies
            document.cookie = "discount_applied=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            document.cookie = "discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            
            // Use fetch to clear discounts without page reload
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: '' })
            });
            
            // Refresh cart contents after clearing discounts
            await window.refreshCartContents(response);
            
            // Reload the page to ensure discount is cleared from Shopify session
            window.location.href = '/cart';
        } else {
            // Just refresh cart contents normally
            window.refreshCartContents(response);
        }
    } catch (error) {
        console.error('Error removing item from cart:', error);
    }
}

// Cart note - Save note via ajax
window.onSaveCartNote = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const note = btn.closest('#cart-note').querySelector('[name="note"]').value

    await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note })
    })

    btn.innerHTML = `✓ <span class="visually-hidden">${btn.dataset.textNoteSaved}</span>`

    setTimeout(() => {
        btn.innerHTML = btn.dataset.textBtnSave
    }, 4000)
}

// Checkout button - indicate loading on click
window.onClickCheckoutBtn = (btn) => {
    btn.style.height = btn.clientHeight + 'px'
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
}

// Cart Goal - Animate width
const initCartGoal = () => {
    const progressBar = document.querySelector('#cart-goal .progress-bar')
    if (progressBar) {
        setTimeout(() => {
            progressBar.style.width = progressBar.dataset.width
        }, 250)
    }
}
initCartGoal()

window.addEventListener('updated.theme.cart', () => {
    initCartGoal()
})

// Summary card on the cart page - sticky on desktop
const initStickySummaryCard = () => {
    const card = document.querySelector('#cart-summary')

    if (!card) return

    if (window.matchMedia('max-width: 991px').matches) return

    const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0
    const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0

    card.style.position = 'sticky'
    card.style.top = `${navbarHeight + announcementBarHeight + 20}px`
}
initStickySummaryCard()

window.addEventListener('updated.theme.cart', () => {
    initStickySummaryCard()
})

// Generate Shipping rates
// https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates
window.generateShippingRates = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const wrapper = document.querySelector('#cart-shipping-rates-collapse')

    wrapper.querySelector('#shipping-rates-modal-alert-danger').innerHTML = ''
    wrapper.querySelector('#shipping-rates-modal-alert-danger').setAttribute('hidden', 'hidden')
    wrapper.querySelector('#shipping-rates-modal-alert-warning').innerHTML = ''
    wrapper.querySelector('#shipping-rates-modal-alert-warning').setAttribute('hidden', 'hidden')
    wrapper.querySelector('#shipping-rates-modal-alert-success').innerHTML = ''
    wrapper.querySelector('#shipping-rates-modal-alert-success').setAttribute('hidden', 'hidden')

    const country = wrapper.querySelector('#shipping-rates-modal-country').value
    const province = wrapper.querySelector('#shipping-rates-modal-province').value
    const zip = wrapper.querySelector('#shipping-rates-modal-zip').value

    const prepareResponse = await fetch(`/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, {
        method: 'POST'
    })
    console.log(prepareResponse)

    if (prepareResponse.ok) {
        const asyncRespose = await fetch(`/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`)
        console.log(asyncRespose)

        const data = await asyncRespose.json()
        console.log(data)

        let html = ''

        if (data.shipping_rates.length) {
            data.shipping_rates.forEach(elem => {
                html += `
                    <li>
                        <strong>${elem.presentment_name}</strong>: ${elem.price} ${elem.currency}
                    </li>
                `
            })

            wrapper.querySelector('#shipping-rates-modal-alert-success').innerHTML = `
                <ul class="ps-5 mb-0">
                    ${html}
                </ul>
            `
            wrapper.querySelector('#shipping-rates-modal-alert-success').removeAttribute('hidden')
        } else {
            wrapper.querySelector('#shipping-rates-modal-alert-warning').innerHTML = `
                <p class="mb-0">
                    ${wrapper.dataset.textNoResults}
                </p>
            `
            wrapper.querySelector('#shipping-rates-modal-alert-warning').removeAttribute('hidden')
        }
    } else {
        const data = await prepareResponse.json()
        console.log(data)

        let html = ''

        for (const [key, value] of Object.entries(data)) {
            html += `
                <li>
                    <strong>${key}</strong>: ${value.toString()}
                </li>
            `
        }

        wrapper.querySelector('#shipping-rates-modal-alert-danger').innerHTML = `
            <ul class="ps-5 mb-0">
                ${html}
            </ul>
        `
        wrapper.querySelector('#shipping-rates-modal-alert-danger').removeAttribute('hidden')
    }

    btn.innerHTML = btn.dataset.text
}

// Offcanvas cart - fix scrolling for callapses
const fixScrollingOffcanvasCollapses = () => {
    document.querySelectorAll('#offcanvas-cart [data-bs-toggle="collapse"]').forEach(elem => {
        elem.addEventListener('click', () => {
            setTimeout(() => {
                const offcanvasBody = document.querySelector('#offcanvas-cart .offcanvas-body')
                offcanvasBody.scroll({ top: offcanvasBody.scrollHeight, behavior: 'smooth' })
            }, 250)
        })
    })
}
fixScrollingOffcanvasCollapses()

window.addEventListener('updated.theme.cart', () => {
    fixScrollingOffcanvasCollapses()
})

// Plus/Minus buttons for cart quantity
window.onClickQtyPlusMinus = (btn) => {
    try {
        // 直接用 parentElement，适配 offcanvas-cart 结构
        const input = btn.parentElement.querySelector("input");
        if (!input) {
            console.error('Error: No input element found');
            return;
        }
        
        const currentValue = parseInt(input.value) || 0;
        const minQty = parseInt(input.dataset.minQty) || 0;
        
        if (btn.dataset.mode === "plus") {
            input.value = currentValue + 1;
        } else if (currentValue > minQty) {
            input.value = currentValue - 1;
        }
        
        // Trigger the change event to update the cart
        const event = new Event('change');
        input.dispatchEvent(event);
    } catch (error) {
        console.error('Error handling quantity change:', error);
    }
}

// Apply discount code
window.applyDiscountCode = async (btn) => {
    try {
        const discountInput = document.getElementById('cart-discount-code');
        const discountCode = discountInput.value.trim();
        
        if (!discountCode) {
            document.getElementById('cart-discount-alert-error').textContent = document.getElementById('cart-discount-alert-error').dataset.errorEmpty || 'Please enter a discount code';
            document.getElementById('cart-discount-alert-error').removeAttribute('hidden');
            document.getElementById('cart-discount-alert-success').setAttribute('hidden', 'hidden');
            return;
        }
        
        // Show loading state
        const originalBtnText = btn.textContent;
        btn.disabled = true;
        btn.innerHTML = `
            <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
                <span class="visually-hidden">Loading...</span>
            </div>
        `;
        
        // Hide previous alerts
        document.getElementById('cart-discount-alert-error').setAttribute('hidden', 'hidden');
        document.getElementById('cart-discount-alert-success').setAttribute('hidden', 'hidden');
        
        try {
            console.log('Applying discount code:', discountCode);
            
            // Set cookies to remember that we've applied a discount code
            document.cookie = "discount_applied=true; path=/; max-age=86400"; // 24 hours
            document.cookie = "discount_code=" + discountCode + "; path=/; max-age=86400"; // 24 hours
            
            // Check if we're in the drawer or the cart page
            const isDrawer = !!document.querySelector('#offcanvas-cart.show');
            const isCartPage = window.location.pathname === '/cart';
            
            // Apply the discount code using Shopify's discount endpoint
            if (isDrawer && !isCartPage) {
                // For drawer, use AJAX to apply discount and stay on the same page
                const response = await fetch('/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart.js');
                
                if (response.ok) {
                    // Show success message
                    document.getElementById('cart-discount-alert-success').removeAttribute('hidden');
                    
                    // Refresh cart contents
                    await window.refreshCartContents(response);
                    
                    // Clear input
                    discountInput.value = '';
                } else {
                    // Show error message
                    document.getElementById('cart-discount-alert-error').textContent = document.getElementById('cart-discount-alert-error').dataset.errorInvalid || 'Invalid discount code';
                    document.getElementById('cart-discount-alert-error').removeAttribute('hidden');
                    
                    // Clear the cookies if the discount code was invalid
                    document.cookie = "discount_applied=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    document.cookie = "discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                }
                
                // Reset button state
                btn.disabled = false;
                btn.textContent = originalBtnText;
            } else {
                // For cart page, redirect to apply the discount
                window.location.href = '/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart';
            }
        } catch (error) {
            console.error('Error applying discount code:', error);
            document.getElementById('cart-discount-alert-error').textContent = document.getElementById('cart-discount-alert-error').dataset.errorGeneral || 'Error applying discount code';
            document.getElementById('cart-discount-alert-error').removeAttribute('hidden');
            
            // Clear the cookies if there was an error
            document.cookie = "discount_applied=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            document.cookie = "discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            
            // Reset button state
            btn.disabled = false;
            btn.textContent = originalBtnText;
        }
    } catch (error) {
        console.error('Error in applyDiscountCode:', error);
        
        // Reset button state
        btn.disabled = false;
        btn.textContent = originalBtnText;
    }
}

// Function to check if a discount should be applied
window.checkAndHandleDiscounts = async () => {
    try {
        // Fetch current cart data
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        console.log('FULL CART DATA:', cart);
        
        // Check if there's a discount applied
        const hasDiscount = cart.original_total_price > cart.total_price;
        
        if (hasDiscount) {
            console.log('Discount detected - checking if it should be applied');
            
            // Get discount applications from the cart
            const discountApplications = cart.cart_level_discount_applications || [];
            console.log('All discount applications:', discountApplications);
            
            // 所有折扣都需要手动输入代码才能应用，除非已经有cookie
            const hasCookieDiscount = document.cookie.includes('discount_applied=true');
            
            // 检查URL中是否包含折扣相关参数
            const urlParams = new URLSearchParams(window.location.search);
            const discountCodeInUrl = urlParams.get('discount');
            const discountInPath = window.location.pathname.includes('/discount/');
            
            console.log('Discount evidence check:', {
                discountCodeInUrl,
                discountInPath,
                hasCookieDiscount,
                pathname: window.location.pathname,
                cookies: document.cookie
            });
            
            // 如果没有cookie或URL中的折扣证据，清除所有非自动折扣
            if (!discountCodeInUrl && !discountInPath && !hasCookieDiscount) {
                console.log('清除所有折扣 - 未在URL、路径或cookie中找到折扣码');
                
                // 清除折扣cookie
                document.cookie = "discount_applied=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                document.cookie = "discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                
                // 使用fetch清除折扣以避免页面重新加载
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ discount: '' })
                });
                
                // 刷新购物车内容
                await window.refreshCartContents({ok: true, url: '/cart.js'});
                
                return;
            } else {
                console.log('保留折扣 - 在URL、路径或cookie中找到了折扣码');
            }
        } else {
            console.log('购物车中未检测到折扣');
        }
    } catch (error) {
        console.error('检查折扣时出错:', error);
    }
}

// Debug function to log discount information
window.logCartDiscounts = async () => {
    try {
        console.log('Checking cart discounts...');
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        console.log('Cart total price:', cart.total_price);
        console.log('Cart original total price:', cart.original_total_price);
        console.log('Has discount:', cart.original_total_price > cart.total_price);
        
        // Log discount applications
        if (cart.cart_level_discount_applications) {
            console.log('Discount applications:', cart.cart_level_discount_applications);
            
            cart.cart_level_discount_applications.forEach((discount, index) => {
                console.log(`Discount ${index + 1}:`, {
                    title: discount.title,
                    type: discount.type,
                    value: discount.value,
                    value_type: discount.value_type,
                    amount: discount.total_allocated_amount
                });
            });
        } else {
            console.log('No cart-level discount applications found');
        }
        
        // Log line item discounts
        if (cart.items && cart.items.some(item => item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0)) {
            console.log('Line item discounts found:');
            
            cart.items.forEach((item, index) => {
                if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
                    console.log(`Item ${index + 1} (${item.title}) has discounts:`, item.line_level_discount_allocations);
                }
            });
        } else {
            console.log('No line item discounts found');
        }
        
        // Check URL and cookies
        const urlParams = new URLSearchParams(window.location.search);
        console.log('Discount in URL param:', urlParams.get('discount'));
        console.log('Discount in path:', window.location.pathname.includes('/discount/'));
        console.log('Discount cookie:', document.cookie.includes('discount_applied=true'));
        
        return cart;
    } catch (error) {
        console.error('Error logging cart discounts:', error);
    }
};

// Function to directly clear all discounts from Shopify session
window.directClearAllDiscounts = async () => {
    try {
        console.log('Directly clearing all discounts from Shopify session...');
        
        // Clear discount cookies
        document.cookie = "discount_applied=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
        
        // Method 1: Navigate directly to clear_discount endpoint
        // This is the most reliable way to clear discounts in Shopify
        window.location.href = '/cart/clear_discount?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);
        return true;
    } catch (error) {
        console.error('Error clearing discounts:', error);
        return false;
    }
};

// Function to check if the cart is empty and clear discounts if needed
window.checkIfCartIsEmpty = async () => {
    try {
        // Get cart data
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        // If cart is empty, clear any discounts
        if (cart.item_count === 0) {
            console.log('Cart is empty - clearing any discounts');
            
            // Clear discount cookies
            document.cookie = "discount_applied=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            document.cookie = "discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            
            // Use fetch to clear discounts without page reload
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: '' })
            });
            return true;
        }
        return false;
    } catch (error) {
        console.error('Error checking if cart is empty:', error);
        return false;
    }
};

// Function to handle checkout with discount control
window.handleCheckout = async (event) => {
    // Prevent default form submission
    if (event) {
        event.preventDefault();
    }
    
    try {
        // Get the checkout button and show loading state
        const checkoutBtn = document.querySelector('.btn-checkout');
        if (checkoutBtn) {
            const originalBtnHtml = checkoutBtn.innerHTML;
            // checkoutBtn.disabled = true;
            // checkoutBtn.innerHTML = `
            //     <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
            //         <span class="visually-hidden">Loading...</span>
            //     </div>
            // `;
            
            // Proceed directly to checkout
            // Let Shopify handle any active discount codes
            window.location.href = '/checkout';
        } else {
            // Fallback if button not found
            window.location.href = '/checkout';
        }
    } catch (error) {
        console.error('Error in handleCheckout:', error);
        // Fallback to standard checkout
        window.location.href = '/checkout';
    }
};

// Run on page load
document.addEventListener('DOMContentLoaded', async () => {
    try {
        // 检查折扣状态并处理
        await window.checkAndHandleDiscounts();
        
        // 检查购物车是否为空并清除折扣（如果需要）
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        console.log('Cart data on page load:', {
            itemCount: cart.item_count,
            totalPrice: cart.total_price,
            originalTotalPrice: cart.original_total_price
        });
        
        // 如果购物车为空，我们应该清除所有折扣
        if (cart.item_count === 0) {
            // 检查我们是否已经在clear_discount重定向上
            if (!window.location.pathname.includes('/cart/clear_discount')) {
                console.log('Cart is empty - clearing any discounts');
                
                // 清除折扣cookie
                document.cookie = "discount_applied=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                document.cookie = "discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                
                // 使用fetch而不是重定向以避免页面重新加载
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ discount: '' })
                });
            }
        }
        
        // Override checkout buttons
        const checkoutButtons = document.querySelectorAll('.btn-checkout');
        checkoutButtons.forEach(button => {
            button.addEventListener('click', window.handleCheckout);
        });
        
        // 已删除清空购物车后需要重新输入折扣码的提示
        
        // Check if we need to open the cart drawer on page load
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('drawer') === 'true') {
            // Open the cart drawer
            const cartDrawer = document.querySelector('#offcanvas-cart');
            if (cartDrawer && window.bootstrap) {
                const bsOffcanvas = new window.bootstrap.Offcanvas(cartDrawer);
                bsOffcanvas.show();
            }
        }
    } catch (error) {
        console.error('Error in DOMContentLoaded handler:', error);
    }
});

// Monitor cart changes to detect when cart becomes empty
const originalXHROpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function(method, url) {
    this.addEventListener('load', async function() {
        if (url.includes('/cart/change') || url.includes('/cart/clear') || url.includes('/cart/update')) {
            try {
                // Get cart data after change
                const cartResponse = await fetch('/cart.js');
                const cart = await cartResponse.json();
                
                // If cart is now empty, clear discounts
                if (cart.item_count === 0) {
                    console.log('Cart is now empty after update - clearing discounts');
                    
                    // Clear discount cookies
                    document.cookie = "discount_applied=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    document.cookie = "discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    
                    // Use fetch to clear discounts without page reload
                    await fetch('/cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ discount: '' })
                    });
                }
            } catch (error) {
                console.error('Error checking cart after update:', error);
            }
        }
    });
    originalXHROpen.apply(this, arguments);
};

// Function to clear cart and all discounts
window.clearCartAndDiscounts = async () => {
    try {
        console.log('Clearing cart and all discounts...');
        
        // Clear the cart first
        const clearCartResponse = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        
        if (clearCartResponse.ok) {
            console.log('Successfully cleared cart');
            
            // Now clear discounts by redirecting to clear_discount
            window.location.href = '/cart/clear_discount?redirect=/cart';
            return true;
        } else {
            console.error('Failed to clear cart');
            return false;
        }
    } catch (error) {
        console.error('Error clearing cart and discounts:', error);
        return false;
    }
};

// Add a console message to help with debugging
console.log('Cart.js loaded with discount control. To manually clear cart and discounts, call window.clearCartAndDiscounts().');
